import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'gender'
})
export class GenderPipe implements PipeTransform {

    transform(value: string): string {

        switch (value) {
            case 'divers':
                return 'Divers'
            case 'weiblich':
                return 'Frau'
            case 'männlich':
                return 'Herr'
            default:
                return ''
        }
    }
}
